import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApiUrlService} from '../api-url/api-url.service';

@Injectable({
  providedIn: 'root',
})
export class ApiIframeAuthService {

  private apiUrlService = inject(ApiUrlService);

  private http = inject(HttpClient);

  /**
   * Method API: Auth for iframe module
   * @param iframeHash
   */
  iframeAuth(iframeHash: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrlService.iframeAuthApiUrl}/${iframeHash}`);
  }

}
